<template>
  <div>
    <el-card>
      <el-form
        :model="userPassword"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item prop="oldPassword">
          <div class="input_box">
            <h5>旧密码:</h5>
            <el-input
              v-model.trim="userPassword.oldPassword"
              placeholder="请输入旧密码"
              show-password
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="Password">
          <div class="input_box">
            <h5>新密码:</h5>
            <div>
              <el-input
                v-model.trim="userPassword.Password"
                placeholder="请输入新密码"
                maxlength="20"
                show-password
                @change="checkpassword"
              ></el-input>
              <p class="text1">密码长度为6-20位，需同时包含大小写字母和数字</p>
            </div>
          </div>
          <div
            class="pmgressbar"
            :class="{
              heightvalue: passwordlavel == 0,
              middlevalue: passwordlavel == 1,
              minvalue: passwordlavel == 2,
            }"
          >
            <span>密码强度：</span>
            <div></div>
            <div></div>
            <div></div>
            <span ref="textPawStyle">{{ textPaw }}</span>
          </div>
        </el-form-item>

        <el-form-item prop="confirmPaw">
          <div class="input_box">
            <h5>再输一次:</h5>
            <el-input
              v-model.trim="userPassword.confirmPaw"
              placeholder="请再输入一次新密码"
              show-password
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="toHome">返回</el-button>
        <el-button type="success" class="submit_btn" @click="ModifyPass()"
          >保存</el-button
        >
      </div>
      <!-- 提示小弹窗 -->
      <div class="delete_view">
        <el-dialog
          title="温馨提示"
          :visible.sync="promptPaw"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          @close="exitBtn"
        >
          <div class="delete_mian">
            <p>密码修改成功,请使用新密码登陆。</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="exitBtn()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import md5 from "js-md5";
import { strongPass, UserPass2, validationPaw } from "@/utils/validata";
import { updatePassWord } from "@/api/examination.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      passwordlavel: "", //密码校验登记
      textPaw: "",
      passwordPercent: 0,
      promptPaw: false, // 密码修改提示框
      userPassword: {
        oldPassword: "", // 旧的独立密码
        Password: "", // 新密码
        confirmPaw: "", // 确认密码
      },
      rules: {
        oldPassword: [{ validator: validationPaw, trigger: "blur" }],
        Password: [{ validator: strongPass(this), trigger: "blur" }],
        confirmPaw: [{ validator: UserPass2(this), trigger: "blur" }],
      },
    };
  },
  methods: {
    // 取消返回首页
    toHome() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Landingpaw:back",
          parent_code: "PersonalCenter:Landingpaw",
        },
        "statetime"
      );
      this.$router.push("/papers");
    },
    submitForm(ruleForm) {
      // 确定校验
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    progressFn() {
      var ptr_digit = /^.*[0-9]+.*$/; // 是否包含数字
      if (this.userPassword.Password === ptr_digit) {
        return "red";
      }
    },
    checkpassword() {
      let minreg = /^\d+$/; //纯数字
      let minreg2 = /^[A-Za-z]+$/; //纯字母
      let meddile = /^([0-9]+[a-zA-Z]+|[a-zA-Z]+[0-9]+)[0-9a-zA-Z]*$/; //字母加数字
      let meddile2 = /^(?![A-z0-9]+$)([A-z~@*()_]+$)(?![A-z0-9~@*()_]{8,})$/; //纯字母加特殊符号
      let meddile3 =
        /^(?![A-z0-9]+$)(?![A-z~@*()_]+$)([0-9~@*()_]+$)(?![A-z0-9~@*()_]{8,})$/; //纯数字和特殊符号
      let heightvalues =
        /^(?![A-z0-9]+$)(?![A-z~@*()_]+$)(?![0-9~@*()_]+$)([A-z0-9~@*.()_]{8,})$/;
      if (minreg.test(this.userPassword.Password)) {
        this.passwordlavel = 0; //纯数字
        console.log("纯数字");
        this.textPaw = "弱";
      }
      if (minreg2.test(this.userPassword.Password)) {
        this.passwordlavel = 0; //纯字母
        console.log("纯字母");
        this.textPaw = "弱";
      }

      if (meddile.test(this.userPassword.Password)) {
        this.passwordlavel = 1; //纯字母
        this.textPaw = "中";
        console.log("字母和数字");
      }
      if (meddile2.test(this.userPassword.Password)) {
        this.passwordlavel = 1; //纯字母
        console.log("纯字母和特殊符号");
        this.textPaw = "中";
      }
      if (meddile3.test(this.userPassword.Password)) {
        this.passwordlavel = 1; //纯字母
        console.log("纯数字和特殊符号");
        this.textPaw = "中";
      }
      if (heightvalues.test(this.userPassword.Password)) {
        this.passwordlavel = 2; //纯字母
        console.log("字母和数字和特殊符号");
        this.textPaw = "高";
      }
    },
    exitBtn() {
      this.promptPaw = false;
      // 清除token
      this.$store.commit("setUser", null);
      localStorage.removeItem("userlist");
      this.$router.push("/login");
    },
    async ModifyPass() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Landingpaw:save",
          parent_code: "PersonalCenter:Landingpaw",
        },
        "statetime"
      );
      let parmars = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        newPwd: md5(this.userPassword.Password),
        oldPwd: md5(this.userPassword.oldPassword),
      };
      const Data = await updatePassWord(parmars);
      console.log(Data.data.Data, 888888);
      if (Data.data.Status === 200) {
        this.$message({
          message: "恭喜你，修改成功",
          type: "success",
        });
        this.promptPaw = true;
      } else {
        this.$message.error(Data.data.Data);
      }
      console.log(Data);
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}
.el-card {
  border: none;
}
::v-deep.el-card__body {
  padding: 24px;
  box-shadow: none !important;
  border: none !important;
}
::v-deep .el-form-item {
  margin-bottom: 30px !important;
}
.el-form {
  margin-top: 56px;
  flex-direction: column;
}
.input_box {
  display: flex;
  // align-items: center;
  //   margin-bottom: 30px;
  //   &:nth-child(1) {
  //     margin-top: 56px;
  //   }
  h5 {
    width: 76px;
    font-size: 16px;
    margin-right: 57px;
  }
  .el-input {
    width: 609px;
    height: 40px;
  }
}
::v-deep .el-form-item__content {
  margin: 0 !important;
}
// 密码强度
.pmgressbar {
  height: 50px;
  // background-color: bisque;
  display: flex;
  //   justify-content: flex-end;
  margin-left: 136px;
  align-items: center;
  span:nth-child(1) {
    display: inline-block;
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-right: 4px;
  }
  span:nth-last-of-type(1) {
    margin-left: 8px;
  }
  div {
    width: 50px;
    height: 5px;
    background: #f1f1f1f1;
    opacity: 1;
    border-right: 1px solid #fff;
    &:nth-last-of-type(1) {
      width: 70px;
      //   background: red;
    }
  }
}
.heightvalue {
  > :nth-child(2) {
    background-color: red;
  }
}
.middlevalue {
  > :nth-child(2) {
    background-color: red;
  }
  > :nth-child(3) {
    background-color: yellow;
  }
}
.minvalue {
  > :nth-child(2) {
    background-color: red;
  }
  > :nth-child(3) {
    background-color: yellow;
  }
  > :nth-child(4) {
    background-color: rgb(0, 255, 85) !important;
  }
}
::v-deep .el-form-item__error {
  left: 135px;
}
.operation {
  margin-top: 306px;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 100px 0 70px 0;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-dialog {
  width: 300px;
  height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 14px;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text1{
  color: #999999;
  margin-left: 6px;
}
</style>